import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

/**
 * Scroll-reveal wrapper. Reveals once, then exposes `is-inview` so CSS can
 * stagger children (cards, title rules) without extra JS.
 */
const AnimateComponent = ({ children, delay = 0 }) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    rootMargin: "0px 0px -10% 0px",
    triggerOnce: true,
  });

  return (
    <motion.div
      ref={ref}
      className={`student-reveal${inView ? " is-inview" : ""}`}
      initial={{ opacity: 0, y: 42 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 42 }}
      transition={{
        duration: 0.8,
        delay,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      {children}
    </motion.div>
  );
};

export default AnimateComponent;
